import type { BackdropProps } from '@mui/material';
import { Backdrop as MuiBackdrop } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import type { FC } from 'react';

export const Backdrop: FC<BackdropProps> = (props) => {
  return (
    <MuiBackdrop
      transitionDuration={0}
      sx={{
        backgroundColor: theme => theme.palette.background.paper,
        zIndex: theme => theme.zIndex.drawer + 1,
      }}
      {...props}
    >
      <CircularProgress size={55} />
    </MuiBackdrop>
  );
};
